document.addEventListener('DOMContentLoaded', function () {
  // Mobile drawer
  var menuToggle = document.getElementById('menuToggle');
  var drawer = document.getElementById('mobileDrawer');
  var drawerClose = document.getElementById('drawerClose');

  if (menuToggle && drawer) {
    menuToggle.addEventListener('click', function () {
      drawer.classList.add('open');
    });
  }
  if (drawerClose && drawer) {
    drawerClose.addEventListener('click', function () {
      drawer.classList.remove('open');
    });
  }

  // Hero carousel arrows
  document.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('section').querySelector('.hero-carousel');
      if (!row) return;
      var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
      row.scrollBy({ left: dir * 320, behavior: 'smooth' });
    });
  });

  // Product page thumbnail swap
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('ProductMainImage');
      if (main && thumb.dataset.full) {
        main.src = thumb.dataset.full;
      }
    });
  });
});
